import { recruitmentAPI, requestrbac, SSOService, notificationAuth } from "@/utils/request";

const userLogin = (data) => {
	return SSOService({
		// url: `auth/realms/hire3x-dev/protocol/openid-connect/token`, //dev
		url: `auth/realms/SimplifyCV/protocol/openid-connect/token`, //staging and prod
		method: "post",
		headers: {
			"content-type": "application/x-www-form-urlencoded;charset=utf-8",
		},
		data,
	});
};

export const userLogOut = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
    method: "post",
    headers: headers,
    data,
  });
};


const projectAccess = () => {
	return requestrbac({
		url: "/access/v2/license-info/",
	});
};

const fetchUserInfo = () => {
	return requestrbac({
		url: "/access/user-information/",
	});
};

const fetchAdminID = (licenseKey, email) => {
	return recruitmentAPI({
		url: "/common/license-info/",
		params: {
			licenseKey,
			email,
		},
	});
};

const clearNotification = (data) => {
	return notificationAuth({
		method: "delete",
		url: "/app-notification/",
		data,
	});
};

export { userLogin, projectAccess, fetchAdminID, fetchUserInfo, clearNotification };
